<template>
  <v-card v-if="messageStats">
    <v-card-text>
      <h3><v-icon>email</v-icon>Messages</h3>
      <table style="font-size: 0.9em">
        <tr>
          <th rowspan="2">Department</th>
          <th colspan="2">
            <router-link :to="{ name: 'unreplied' }">Unreplied</router-link>
          </th>
          <th colspan="2">Today</th>
        </tr>
        <tr>
          <th>Exp</th>
          <th>Ttl</th>
          <th>Rcvd</th>
          <th>Ansd</th>
        </tr>
        <tr v-for="(messageStat, msindex) in messageStats" :key="msindex">
          <td
            :class="`department${messageStat.department.id}`"
            v-if="messageStat.department != undefined"
          >
            {{ messageStat.department.name }}
          </td>
          <td class="message-count">{{ messageStat.unrepliedOld }}</td>
          <td class="message-count">{{ messageStat.unreplied }}</td>
          <td class="message-count">{{ messageStat.received }}</td>
          <td class="message-count">{{ messageStat.replied }}</td>
        </tr>
      </table>

      <div v-for="(messageStat, msindex) in messageStats" :key="msindex">
        <div
          v-if="messageStat.oldMessage"
          :class="messageStat.oldMessage.styleClass"
        >
          <div>
            <strong>file:</strong>
            <FileGql :file="messageStat.oldMessage.file" bookmark="fundview" />
            <v-chip color="info" text-color="white" small
              >{{ messageStat.oldMessage.age }} days</v-chip
            >
            <br />
            <EntityZ
              v-if="messageStat.oldMessage.user"
              :entity="messageStat.oldMessage.user"
            />
          </div>
          <div v-if="messageStat.oldMessage.age > 4">
            <!-- <marquee>{{messageStat.oldMessage.body}}</marquee> -->
            <read-more
              more-str="more"
              :text="messageStat.oldMessage.body"
              link="#"
              less-str="less"
              :max-chars="150"
            />
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import MESSAGE_STATS from "@/graphql/message/MessageStats";
import MESSAGE_UPDATED from "@/graphql/message/MessageUpdated";
import EntityZ from "@/components/link/EntityZ";
import FileGql from "@/components/link/FileGql";
export default {
  name: "MessageStats",
  components: {
    EntityZ,
    FileGql
  },
  apollo: {
    messageStats: {
      query: MESSAGE_STATS,
      subscribeToMore: {
        document: MESSAGE_UPDATED,
        updateQuery: (previousResult, { subscriptionData }) => {
          return {
            messageStats: { ...subscriptionData.data.messageUpdated }
          };
        }
      }
    }
  }
};
</script>

<style>
.message-count {
  text-align: right;
}
</style>
